import { render } from "./PaginationControls.vue?vue&type=template&id=44bf89c7&scoped=true"
import script from "./PaginationControls.vue?vue&type=script&lang=js"
export * from "./PaginationControls.vue?vue&type=script&lang=js"

import "../css/components/PaginationControls.css?vue&type=style&index=0&id=44bf89c7&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44bf89c7"]])

export default __exports__